import { networkApi } from '../infrastructure/api/NetworkApiClient';

export const removeCableConnection = async (kvsId: string, cableId: string): Promise<void> => {
  try {
    await networkApi.zonePost(`/network/kvs/${kvsId}/remove-cable-connection`, {
      cableId
    });
  } catch (error) {
    console.error('Error removing cable connection:', error);
    throw error;
  }
};
